<app-loading-panel [isLoading]="isLoading"></app-loading-panel>
<kendo-scheduler [kendoSchedulerBinding]="events | async" [selectedDate]="today" [startTime]="options.startTime"
  [endTime]="options.endTime" [selectedViewIndex]="options.selectedViewIndex" [workWeekEnd]="6">
  
  <ng-template kendoSchedulerEventTemplate kendoSchedulerAllDayEventTemplate let-event="event">
    <div [ngClass]="setColor(event.description)" [innerHtml]="event.title"></div>
  </ng-template>

  <ng-template kendoSchedulerToolbarTemplate>
    <button kendoSchedulerPDFCommand>
      {{ "global.exportPdf" | translate }}
    </button>
    <div kendoSchedulerToolbarNavigation></div>
    <span class="k-spacer"></span>

    <div kendoSchedulerToolbarViewSelector>
      
    </div>

    {{'global.schedulerViewDetails' | translate}}
    <kendo-switch [ngModel]="isDetailedView" (valueChange)="isDetailedViewChanged($event)" class="button-with-margin">
  </kendo-switch>

  </ng-template>



  <kendo-scheduler-day-view> </kendo-scheduler-day-view>
  <kendo-scheduler-work-week-view> </kendo-scheduler-work-week-view>
  <kendo-scheduler-month-view> </kendo-scheduler-month-view>
  <kendo-scheduler-agenda-view> </kendo-scheduler-agenda-view>
  <kendo-scheduler-timeline-view> </kendo-scheduler-timeline-view>

  <kendo-scheduler-pdf [fileName]="fileName"> </kendo-scheduler-pdf>
</kendo-scheduler>